import { useOnboardingContext } from '../../../../contexts';
import { useMobile } from '../../../../hooks/useMobile';
import { getTotalOnboadingSteps } from './get-total-onboarding-steps';

export function useGetOnboardingProgress(): number {
  const mobile = useMobile('sm');
  const { activeStep } = useOnboardingContext();
  const totalOnboardingSteps = getTotalOnboadingSteps(mobile);
  return (activeStep / totalOnboardingSteps) * 100;
}
